import React, { ReactElement } from 'react';

import { shouldRenderMobile } from '@philips-emr/hpms-provider-commons';
import providerContext from '@philips-emr/hpms-provider-commons/lib/context/provider-context';
import { FetchAPI, FilterAPI, Panel, Token } from '@philips-emr/tws-components';
import { LayoutAlign, LayoutJustify, Type } from '@philips-emr/tws-constants';
import Controller, { OnDynamicContentRender, OnMount, OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';
import { MessageService } from '@philips-emr/tws-core/lib/services';
import { generateUUID } from '@philips-emr/tws-utils';

import { MeetingMinuteConsultationAliases as Aliases, FragmentNames } from '../../codegen';
import { Route } from '../../route';
import BaseController from '../BaseController';

interface MeetingMinute {
  dsMeetingminute: string;
  dsProvider: string;
  dtMeetingMinute: string;
  iePending: string;
  nrSeqProjMeetingMinute: string;
  nrSeqProviderMeetingMinute: number;
  ieStatus: MeetingMinutesValueStatus;
  dsStatus: string;
  messageRefuse: string;
}

enum MeetingMinutesValueStatus {
  ACCEPT = 'A',
  REFUSED = 'R',
  PENDING = 'P',
  CANCELED = 'C',
}

@Controller({ fragment: FragmentNames.MEETING_MINUTE_CONSULTATION })
class MeetingMinutesConsultationController extends BaseController {

  @OnMount(Aliases.FILTER_MEETING_MINUTE_CONSULTATION)
  onMountFilter(event: MountEvent): void {
    const api = event.target as FilterAPI;
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;
    api.setData({ nrSeqProvider });
  }

  @OnMount(Aliases.FETCH_MEETING_MINUTE_CONSULTATION)
  onMountFetchMeetingMinutesConsultation(event: MountEvent): void {
    const api = event.target as FetchAPI;
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;
    api.setParameters({ nrSeqProvider });
    api.forceFetch();
  }

  @OnDynamicContentRender(Aliases.CARD_MEETING_MINUTE_CONSULTATION)
  onRenderCardTask(event: RenderEvent): void {
    if (event.data) {
      const { data, render } = event;
      const { iePending } = data as MeetingMinute;
      if (iePending === 'S') {
        render(() : ReactElement  => renderTokenPending());
      }
    }
  }

  @OnSelectItem(Aliases.DECK_MEETING_MINUTE_CONSULTATION)
  onClickCardVisit(event: SelectItemEvent<MeetingMinute>): void {
    const { nrSeqProviderMeetingMinute } = event.item;
    this.historyService.push(Route.MEETING_MINUTE_DETAILS, { nrSeqProviderMeetingMinute });
  }
}

function renderTokenPending(): ReactElement {
  if (shouldRenderMobile()) {
    return <Panel className="token-meeting-minute" uuid={generateUUID()}>
      <Token value={MessageService.translate('provider.waiting-acceptance')} type={Type.WARNING} />
    </Panel>;
  }
  return <Panel className="" uuid={generateUUID()} margin="0 0 0 1.5rem" justifyContent={LayoutJustify.CENTER} alignItems={LayoutAlign.CENTER}>
    <Token value={MessageService.translate('provider.waiting-acceptance')} type={Type.WARNING} />
  </Panel>;
}

export {
  MeetingMinute,
  MeetingMinutesValueStatus,
  MeetingMinutesConsultationController,
};
